import {FETCH_TYPES, parseURL} from "../Connect";
import SystemConfig, {CONFIG_PARAMS, GAMECONF_PARAMS} from "../../system/SystemConfig";
import FetchAjax from "../FetchAjax";
import IConnectControl from "../controllers/IConnectControl";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import AbstractConnect from "./AbstractConnect";
import IDOM from "../../ui/IDOM";

@injectable()
class ConnectAjaxClose extends AbstractConnect {

    public readonly fetchType: string = FETCH_TYPES.CLOSE;
    timeout: number = 20000;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
        @inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
    ) {

        super(config, control, fetch, dom);

        // use gameconf connect timeout if set,
        if (this.config.get(CONFIG_PARAMS.TIMEOUTS) && this.config.get(CONFIG_PARAMS.TIMEOUTS).close > 0) {
            this.timeout = this.config.get(CONFIG_PARAMS.TIMEOUTS).close * 1000;
        }
        this.setMethod(this.config.get(CONFIG_PARAMS.URL_CLOSE_METHOD));
    }

    async fetch(data) {
        this.control.reset();
        this.data = data;

        return this._fetch();
    }

    protected getParams(): Record<string, any> {
        if (this.data.soft !== undefined) {
            return {
                session_id: this.data.sessionId,
                casino_id: this.data.casinoId,
                ended: "true",
                soft: this.data.soft
            };
        } else {
            return {
                session_id: this.data.sessionId,
                casino_id: this.data.casinoId,
                ended: "true",
            };
        }

    }

    protected getUrl(): string {
        return parseURL(this.config.get(CONFIG_PARAMS.URL_CLOSE), {
            "server_api": this.data.serverApi,
            "session_id": this.data.sessionId,
            "casino_id": this.data.casinoId
        });
    };
}

export default ConnectAjaxClose;